// import * as React from 'react';
import { createStore, applyMiddleware } from 'redux';
import reducers from '../reducers/reducers';
import createSagaMiddleware from 'redux-saga';
import subscriptionRequestSaga from '../sagas/subscriptionRequestSaga';
import entitySaga from '../sagas/entitySaga';
import communitiesSaga from "../sagas/communitiesSaga";

const sagaMiddleware = createSagaMiddleware();
// tslint:disable-next-line:no-string-literal
const devtools: any = window['devToolsExtension'] ? window['devToolsExtension']() : (f: any) => f;
const middleware = applyMiddleware(sagaMiddleware);
const store: any = middleware(devtools(createStore))(reducers);

sagaMiddleware.run(subscriptionRequestSaga);
sagaMiddleware.run(entitySaga);
sagaMiddleware.run(communitiesSaga)
export default store;



// WEBPACK FOOTER //
// ./src/modules/core/store/index.tsx